import React, { useMemo } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { DropdownButton } from "../../dropdownButton";
import styles from ".././currentClientContainer/currentClientContainer.css";
import { observer } from "mobx-react";
import { useStore } from "../../../models";
import classNames from "classnames";
import { ToastMessageType } from "../../../models/ui";
import { PluginService } from "../../../plugins/pluginService";
import { logger } from "@fidget/common/utils";

export const OmniButton = observer(() => {
  const pluginService = useMemo(() => PluginService.getInstance(), []);
  const { currentUserStore, uiStore } = useStore();
  const externalIntegrationName = currentUserStore?.orgConfig?.externalIntegrationName;

  return (
    <>
      {externalIntegrationName && pluginService.hasActivePlugin(externalIntegrationName) && (
        <a
          href={"javascript:void()"}
          target="_blank"
          className={styles["link-button"]}
          rel="noreferrer noopener"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            try {
              pluginService.omniButtonClick(externalIntegrationName, uiStore.currentRoomReference?.owner!);
            } catch (ex) {
              logger.error({ message: "crm integration error", error: ex });
              uiStore.addToastMessage(
                intl.formatMessage("conversation.omni.integration.error"),
                ToastMessageType.DANGER
              );
            }
          }}
        >
          <DropdownButton
            label={intl.formatMessage(`conversation.omni.integration.${externalIntegrationName}` as any)}
            options={[]}
            onAction={() => undefined}
            className={classNames([styles["close-conversation-button"], styles["omni-button"]])}
          />
        </a>
      )}
    </>
  );
});
